import React, { Component } from 'react'
import { Rating } from 'semantic-ui-react'

export default class MyRating extends Component {
    render() {
        return <Rating defaultRating={this.props.rate} maxRating={5} disabled />
    }
}
